import React, { useEffect, useState } from 'react'
import { supabase } from '../../utils/supabaseClient'
import { User } from '@supabase/supabase-js'
import Button from '../button/button'
import styles from './menu.module.css'
import {NavLink} from "react-router-dom";

const BurgerIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => (
	<div className={styles.burger_icon} onClick={onClick}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3 12H21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M3 6H21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M3 18H21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	</div>
)

const Menu: React.FC = () => {
	const [user, setUser] = useState<User | null>(null)
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

	const login = async () => {
		await supabase.auth.signInWithOAuth({
			provider: 'github',
			options: {
				redirectTo: 'http://localhost:3000', // Ensure redirect URL is correct
			},
		})
	}

	const logout = async () => {
		await supabase.auth.signOut()
	}

	useEffect(() => {
		const { data: authListener } = supabase.auth.onAuthStateChange(
			(event, session) => {
				setUser(session?.user ?? null)
			}
		)

		// Check initial session state
		supabase.auth.getSession().then(({ data: { session } }) => {
			setUser(session?.user ?? null)
		})

		return () => {
			authListener.subscription.unsubscribe()
		}
	}, [])


	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen)
	}

	return (
		<>
			<div className={styles.main_menu}>
				<img src={'/logo.svg'} alt={'Pitch Invasion'} />
				<div className={styles.menu_container}>
					<ul className={styles.menu_top}>
						<li>
							<NavLink
								className={({ isActive }) =>
									isActive ? styles.menu__active_item : styles.menu__item
								}
								to='/admin'
							>
								Admin panel
							</NavLink>
						</li>
					</ul>
					<ul className={styles.menu_bottom}>
						<li>
							<NavLink
								className={({ isActive }) =>
									isActive ? styles.menu__active_item : styles.menu__item
								}
								to='/tournaments'
							>
								Competitions
							</NavLink>
						</li>
						<li>
							<NavLink
								className={({ isActive }) =>
									isActive ? styles.menu__active_item : styles.menu__item
								}
								to='/matches'
							>
								Matches
							</NavLink>
						</li>
						<li>
							<NavLink
								className={({ isActive }) =>
									isActive ? styles.menu__active_item : styles.menu__item
								}
								to='/teams'
							>
								Teams
							</NavLink>
						</li>
						<li>
							<NavLink
								className={({ isActive }) =>
									isActive ? styles.menu__active_item : styles.menu__item
								}
								to='/persons'
								>
								Persons
							</NavLink>
						</li>
						<li>
							<NavLink
								className={({ isActive }) =>
									isActive ? styles.menu__active_item : styles.menu__item
								}
								to='/library'
							>
								Library
							</NavLink>
						</li>
					</ul>
				</div>
				<BurgerIcon onClick={toggleMobileMenu} />
				{user && user.identities ? (
					<Button
						onClick={logout}
						text={user.identities[1]?.identity_data?.name}
						arrow={false}
					/>
				) : (
					<Button onClick={login} text={'Sign in with GitHub'} arrow={false} />
				)}
			</div>
			<div className={`${styles.mobile_menu} ${isMobileMenuOpen ? styles.open : ''}`}>
				<ul>
					<li>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menu__active_item : styles.menu__item
							}
							to='/admin'
						>
							Admin panel
						</NavLink>
					</li>
					<li>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menu__active_item : styles.menu__item
							}
							to='/tournaments'
						>
							Competitions
						</NavLink>
					</li>
					<li>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menu__active_item : styles.menu__item
							}
							to='/matches'
						>
							Matches
						</NavLink>
					</li>
					<li>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menu__active_item : styles.menu__item
							}
							to='/teams'
						>
							Teams
						</NavLink>
					</li>
					<li>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menu__active_item : styles.menu__item
							}
							to='/persons'
						>
							Persons
						</NavLink>
					</li>
					<li>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menu__active_item : styles.menu__item
							}
							to='/library'
						>
							Library
						</NavLink>
					</li>
				</ul>
			</div>
		</>
	)
}

export default Menu